import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const tdsTxnViewAll = createAsyncThunk(
  "tdsTxnViewAll/fetch",
  async (values = {}, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      lifecycle_status,
      category,
      search_string,
      payment_method,
      beneficiary_account_id,
      tds_account_id,
      distribution_lifecycle_status,
      start_date,
      end_date,
      amount,
      owner_account_id,
      category_value,
      category_name,
      txn_id,
      refactor,
      labels,
      additional_data,
      created_via,
      sort_by,
      min_amount,
      max_amount,
    } = values;

    try {
      const response = await axiosInstance.get(`${baseUrl}/transactions/tds`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no,
          page_size,
          lifecycle_status,
          distribution_lifecycle_status,
          category,
          search_string,
          payment_method,
          beneficiary_account_id,
          tds_account_id,
          start_date,
          end_date,
          amount,
          owner_account_id,
          category_value,
          category_name,
          txn_id,
          refactor,
          labels,
          additional_data,
          created_via,
          sort_by,
          min_amount,
          max_amount,
        },
      });

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const taxTxnNewAddLabel = createAsyncThunk(
  "taxTxnNewAddLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/tds/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("taxTxnAvailableLabels") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("taxTxnAvailableLabels", payload);

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else if (error?.response?.data) {
        CommonToast({
          text: error?.response?.data?.ids?.unsuccessful_ids?.[0].errors,
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const taxTxnRemoveLabel = createAsyncThunk(
  "taxTxnRemoveLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/tds/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else if (error?.payload?.response?.data) {
        CommonToast({
          text: error?.payload?.response?.data?.ids?.unsuccessful_ids?.[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

const tdsTxnViewAllSlice = createSlice({
  name: "tdsTxnViewAll",

  initialState: {
    storedPage: 1,
    toggle: false,
    isblur: false,
    taxTxnAvailableLabels: [],

    tdsTxnViewAllData: null,
    tdsTxnViewAllLoading: false,
    tdsTxnViewAllError: null,

    taxTxnAddLabelsLoading: true,
    taxTxnAddLabelsData: [],
    taxTxnAddLabelsError: false,

    taxTxnRemoveLabelsLoading: true,
    taxTxnRemoveLabelsData: [],
    taxTxnRemoveLabelsError: false,
  },

  reducers: {
    resetTdsTxnToggle: (state) => {
      state.toggle = false;
    },
    setAvailabelLabels: (state, action) => {
      state.taxTxnAvailableLabels = action.payload;
    },
    resetTdsTxnViewAll: (state) => {
      state.tdsTxnViewAllData = null;
      state.tdsTxnViewAllLoading = false;
      state.tdsTxnViewAllError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(tdsTxnViewAll.pending, (state, action) => {
        if (action?.payload?.summary?.available_labels) {
          state.taxTxnAvailableLabels = [];
        }
        state.tdsTxnViewAllLoading = true;
        state.tdsTxnViewAllError = null;
      })
      .addCase(tdsTxnViewAll.fulfilled, (state, action) => {
        state.taxTxnAvailableLabels =
          action?.payload?.summary?.available_labels;
        if (action?.payload?.summary?.available_labels) {
          sessionStorage.setItem(
            "taxTxnAvailableLabels",
            JSON.stringify(action?.payload?.summary?.available_labels || []),
          );
        }
        state.tdsTxnViewAllLoading = false;
        state.tdsTxnViewAllData = action.payload;
      })
      .addCase(tdsTxnViewAll.rejected, (state, action) => {
        if (action?.payload?.summary?.available_labels) {
          state.taxTxnAvailableLabels = [];
        }
        state.tdsTxnViewAllLoading = false;
        state.tdsTxnViewAllError = action.payload;
      });
    builder.addCase(taxTxnNewAddLabel.pending, (state, action) => {
      state.taxTxnAddLabelsLoading = true;
    });
    builder.addCase(taxTxnNewAddLabel.fulfilled, (state, action) => {
      state.taxTxnAddLabelsLoading = false;
      state.taxTxnAddLabelsData = action.payload;
    });
    builder.addCase(taxTxnNewAddLabel.rejected, (state, action) => {
      state.taxTxnAddLabelsLoading = false;
      state.taxTxnAddLabelsError = action.payload;
      state.taxTxnAddLabelsData = null;
    });
    builder.addCase(taxTxnRemoveLabel.pending, (state, action) => {
      state.taxTxnRemoveLabelsLoading = true;
    });
    builder.addCase(taxTxnRemoveLabel.fulfilled, (state, action) => {
      state.taxTxnRemoveLabelsLoading = false;
      state.taxTxnRemoveLabelsData = action.payload;
    });
    builder.addCase(taxTxnRemoveLabel.rejected, (state, action) => {
      state.taxTxnRemoveLabelsLoading = false;
      state.taxTxnRemoveLabelsError = action.payload;
      state.taxTxnRemoveLabelsData = null;
    });
  },
});

export const { resetTdsTxnViewAll, resetTdsTxnToggle, setAvailabelLabels } =
  tdsTxnViewAllSlice.actions;

export default tdsTxnViewAllSlice.reducer;
